import { createAction, props } from "@ngrx/store";
import { GlobalSettingInterface } from "../../../models/globalsettingInterface";

export enum AraayActionTypes {
  retrive = "[array Object] set "
}

export const retriveGlobalSetting = createAction(AraayActionTypes.retrive, props<{ settigns: GlobalSettingInterface[] }>());
